import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "ml-2 mr-2 flex justify-between" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "image", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "text-sm" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "delete", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["onClick", "src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.remix.image)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onSelectRemix && _ctx.onSelectRemix(...args))),
          class: _normalizeClass(["overflow-hidden border-2 border-solid", `${_ctx.isRemixType ? 'border-blue-400' : 'border-slate-200'}`])
        }, [
          _createElementVNode("img", {
            src: _ctx.remix.image,
            style: _normalizeStyle(`width:${_ctx.canvasParams.sidew}px;height:${_ctx.canvasParams.sidew}px;Transform:${_ctx.transform};`)
          }, null, 12, _hoisted_1)
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onOpen && _ctx.onOpen(...args))),
        class: ""
      }, _hoisted_4),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$tc("dfraw.remix")), 1),
      _createElementVNode("button", {
        style: _normalizeStyle(`opacity:${_ctx.remix.image ? '1.0' : '0.5'}`),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onSelect(null))),
        class: "ml-2 flex"
      }, _hoisted_7, 4)
    ]),
    (_ctx.showPopup)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          style: _normalizeStyle(`width:${(_ctx.canvasParams.canw * 2) / 3}px;
              left: ${_ctx.canvasOffset.x + _ctx.canvasParams.canw / 3}px; 
              top: ${_ctx.canvasOffset.y}px`),
          class: "absolute border-2 border-solid border-blue-700 bg-slate-100"
        }, [
          _createElementVNode("div", {
            style: _normalizeStyle(`height:${_ctx.canvasParams.canh / 3}px; overflow-y:scroll`)
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.remixes, (remix) => {
              return (_openBlock(), _createElementBlock("span", {
                key: remix.tokenId
              }, [
                _createElementVNode("img", {
                  onClick: ($event: any) => (_ctx.onSelect(remix)),
                  src: remix.image,
                  class: "mr-1 mb-1 inline-block w-14 rounded-xl"
                }, null, 8, _hoisted_8)
              ]))
            }), 128))
          ], 4)
        ], 4))
      : _createCommentVNode("", true)
  ]))
}